import { Property } from "../models/Property";
import { HomeownerApi } from "./apiServices/HomeownerApi";
import { UtilService } from "./Util.service";
import { NetworkErrorService } from "./NetworkError.service";
import { UserStore } from "./stores/UserStore";
import { take } from "rxjs/operators";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class PropertiesService {
    properties: Property[];

    constructor(@Inject(HomeownerApi) private HomeownerApi: HomeownerApi,
                @Inject(UtilService) private UtilService: UtilService,
                @Inject(NetworkErrorService) private NetworkErrorService: NetworkErrorService,
                @Inject(UserStore) private userStore: UserStore) {}

    getProperties(): Observable<Property[]>{

        return new Observable<Property[]>(observer => {
            if (this.properties) {
                observer.next(this.properties);
            } else {
                let userId = this.userStore.getHoaHomeownerId();
                this.HomeownerApi.homeownersIdPropertiesGet(userId).subscribe({
                    next: data => {
                        this.properties = data;
                        for (let i = 0; i < this.properties.length; i++) {
                            if (this.properties[i].nextPaymentDueDate) {
                                this.properties[i].nextPaymentDueDate.formattedFullDate =
                                    this.UtilService.dateFormat(this.properties[i].nextPaymentDueDate.month,
                                        this.properties[i].nextPaymentDueDate.day,
                                        this.properties[i].nextPaymentDueDate.year);
                            }
                        }
                        observer.next(this.properties);
                    },
                    error: (err) => {
                        this.NetworkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.getProperties();
                                }
                                observer.error();
                            });
                    }
                });
            }
        })
    }

    updateProperties(properties: Property[]) {
        this.properties = properties;
    }

}

